import { Navigate } from "react-router-dom";
/* Private team app — public registration is disabled.
   New users are seeded via backend or admin. */
export default function Register() { return <Navigate to="/login" replace />; }
